import React from "react";
import { Badge, Dropdown } from "antd";
import type { MenuProps } from "antd";
import {
  ScanOutlined,
  CheckCircleOutlined,
  SettingOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import "./MobileBottomNav.css";

interface MobileBottomNavProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  deliveryCount: number;
  storageCount: number;
  completedCount: number;
  totalCount: number;
  autoScanEnabled: boolean;
  onToggleAutoScan: () => void;
  onShowOverview: () => void;
  isUnloadingInProgress?: boolean;
  onResetContainer?: () => void;
}

export const MobileBottomNav: React.FC<MobileBottomNavProps> = ({
  activeTab,
  onTabChange,
  deliveryCount,
  storageCount,
  completedCount,
  totalCount,
  autoScanEnabled,
  onToggleAutoScan,
  onShowOverview,
  isUnloadingInProgress = false,
  onResetContainer,
}) => {
  return (
    <div className="mobile-bottom-nav">
      <button
        className={`nav-item ${activeTab === "delivery" ? "active" : ""}`}
        onClick={() => onTabChange("delivery")}
      >
        <div className="nav-icon">
          <Badge count={deliveryCount} size="small" offset={[8, -4]}>
            🚚
          </Badge>
        </div>
        <span className="nav-label">Delivery</span>
      </button>

      <button
        className={`nav-item nav-scan ${autoScanEnabled ? "scanning" : ""}`}
        onClick={onToggleAutoScan}
      >
        <div className="nav-icon scan-icon">
          <ScanOutlined style={{ fontSize: 24 }} />
        </div>
        <span className="nav-label">
          {autoScanEnabled ? "Scanning" : "Scan"}
        </span>
      </button>

      <button
        className={`nav-item ${activeTab === "storage" ? "active" : ""}`}
        onClick={() => onTabChange("storage")}
      >
        <div className="nav-icon">
          <Badge count={storageCount} size="small" offset={[8, -4]}>
            📦
          </Badge>
        </div>
        <span className="nav-label">Storage</span>
      </button>

      {isUnloadingInProgress && onResetContainer ? (
        <Dropdown
          menu={{
            items: [
              {
                key: "overview",
                label: "Show Overview",
                icon: <CheckCircleOutlined />,
                onClick: onShowOverview,
              },
              {
                key: "reset",
                label: "Reset Container",
                icon: <ReloadOutlined />,
                danger: true,
                onClick: onResetContainer,
              },
            ] as MenuProps["items"],
          }}
          trigger={["click"]}
          placement="top"
        >
          <button className="nav-item nav-progress">
            <div className="nav-icon">
              <CheckCircleOutlined
                style={{
                  fontSize: 24,
                  color:
                    completedCount === totalCount && totalCount > 0
                      ? "#52c41a"
                      : "#8c8c8c",
                }}
              />
            </div>
            <span className="nav-label">
              {completedCount}/{totalCount}
            </span>
          </button>
        </Dropdown>
      ) : (
        <button className="nav-item nav-progress" onClick={onShowOverview}>
          <div className="nav-icon">
            <CheckCircleOutlined
              style={{
                fontSize: 24,
                color:
                  completedCount === totalCount && totalCount > 0
                    ? "#52c41a"
                    : "#8c8c8c",
              }}
            />
          </div>
          <span className="nav-label">
            {completedCount}/{totalCount}
          </span>
        </button>
      )}
    </div>
  );
};
